<!--
    描述：评价系统入口页面
    时间：2022-5-18 11:22:20
    Created by 钱磊
-->
<template>
	<transition name="fade"
				mode="out-in">
		<!-- 用做缓存页面 -->
		<keep-alive :include="cachedViews">
			<router-view :key="key" />
		</keep-alive>
	</transition>
</template>

<script>
import { mapState } from 'vuex'
export default {
	name: 'AssessmentEntry',
	data() {
		return {}
	},
	methods: {},
	computed: {
		...mapState('tags', {
			cachedViews: state => state.cacheTags
		}),
		key() {
			return this.$route.name
		}
	}
}
</script>

<style scoped lang="less">
</style>
